

export const stateMapping = ({
    openForm: false,
    sideAction: '',
    displaySpinner: true,
    filteredSettingList: [],
    settingList: [],
    sortBySelected: '',
    sortOrder: 'Ascending',
    showDeleteDialog: false,
    responseStatus: '',
    showResponseDialog: '',
    settingSelected: {},
    responseStatusText: '',
    searchValue: '',
    shiftTemplatesList: [],
    scheduleRules: [],
    selectShiftSetList: [],
    selectZoneSetList: [],
    dataviewColumns: [],
    currentView: 'dashboard', // 'dashboard' or 'globalSetup'
    data: {
        dataviews: [],
        hyperfindQueries: [],
        notifications: [],
        payCodes: [],
        scheduleRuleSets: [],
        shiftSets: [],
        shiftTemplates: [],
        zoneSets: []
    }});


export const mapHyperFindLabelToSettings = (allSettings, allData) =>{
    const hyperfinds = allData.data.hyperfindQueries;

    return allSettings.data.map(setting => {
        const workplan = hyperfinds.find(hfq => hfq.value === setting.createTemplatesHyperfind);
        const shiftline = hyperfinds.find(hfq => hfq.value === setting.manageShiftlinesHyperfind);
        const assignment = hyperfinds.find(hfq => hfq.value === setting.manageAssignmentsHyperfind);
        setting.createTemplatesHyperfind = workplan ? workplan.label : "";
        setting.manageShiftlinesHyperfind = shiftline ? shiftline.label : "";
        setting.manageAssignmentsHyperfind = assignment ? assignment.label : "";
        return setting;
    })
};

export const mapDataToSettings = (allData) => ({
    ...allData.data,
    payCodes: allData.data.payCodes.map(payCode => { return { ...payCode, id: payCode.value } })
})

export const mapNotificationToSettings = (notifications) => notifications.data.map((x) => ({ value: x.id, label: x.name }));

export const handleSearchFilter = (value, settingList, handleStatePropChange) => {
    if (value === '') {
        handleStatePropChange('filteredSettingList', settingList)
        return;
    }

    let pattern = /\s{2,}/g;
    let searchedValue = value.trim().toLowerCase();
    let formattedSearchedValue = searchedValue.replace(pattern, " ");

    const filteredSettings = settingList.filter((setting) => {
        for (const key in setting) {
            if (Object.hasOwnProperty.call(setting, key) && key !== 'id' && key !== 'isUsed') {
                
                let keySetting = String(setting[key]).trim().toLowerCase();
                let formattedKeySetting = keySetting.replace(pattern, " ");;
                if (formattedKeySetting.includes(formattedSearchedValue)) {
                    return true;
                }
            }
        }
        return false;
    })
    handleStatePropChange('filteredSettingList', filteredSettings)
}